import { App } from 'vue'

import './chart'
import { router } from '@/router'
import { vuetify } from './vuetify'
import { store } from './pinia'
import { register as luxon } from './luxon'
import { register as permissions } from './permissions'
import { register as formatters } from './formatters'
import { register as masks } from './masks'

export function register(app: App) {
  app.use(store)
  app.use(router)
  app.use(luxon)
  app.use(vuetify)
  app.use(permissions)
  app.use(formatters)
  app.use(masks)
}
